import { render, staticRenderFns } from "./Weeks.vue?vue&type=template&id=981bb810&"
import script from "./Weeks.vue?vue&type=script&lang=js&"
export * from "./Weeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports